/**
 * Mensaje de error general del formulario (no asociado a un campo).
 *
 * Estilo informativo, no alarmista (regla de marca). Texto en bone-muted
 * sobre fondo carbon-raised, borde sutil. role="alert" para anunciar a
 * screen readers cuando aparece tras submit.
 */

interface Props {
  message: string | null;
}

export function FormError({ message }: Props) {
  if (!message) return null;
  return (
    <div
      role="alert"
      className="rounded-md border border-border-subtle bg-carbon-raised px-3 py-2.5 text-sm text-bone-muted"
    >
      {message}
    </div>
  );
}
